import gql from "graphql-tag";

export const MY_HR_CLEAR_FAILED_CODE = gql`
  mutation clearFailedCode($email: String!) {
    clearFailedCode(email: $email)
  }
`;
